import { createAsyncThunk } from '@reduxjs/toolkit'
import { getAllChatsService, getChatLanguageRoomsService, sendChatService } from 'network/services/chat.service'

export const getAllChats = createAsyncThunk('chats/all-Chats', async (params, thunkApi) => {
  try {
    const res = await getAllChatsService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getChatLanguageRooms = createAsyncThunk('chats/chat-language-rooms', async (params, thunkApi) => {
  try {
    const res = await getChatLanguageRoomsService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const sendChat = createAsyncThunk('chat/message-sent', async (data, thunkApi) => {
  try {
    const res = await sendChatService(data)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})
